import * as React from 'react';
import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';
import { useToggleable } from '../../../../../../hooks';
import { format, MOBILE_MIN_WIDTH, TABLET_MIN_WIDTH } from '../../../../../../utils';
import { BaseButton, Header, ModalX } from '../../../../../../BaseComponents';
import { useAvailableDates } from '../../../../../../Modules/Exchange/components/Exchange/hooks';
import DatepickerComponent from '../../../../../../Modules/Exchange/components/Exchange/SearchFlights/Calendar/Datepicker/Datepicker';
import { CdnIcon } from '@shared/ui';
const SelectDate = ({ date, minDate, selectedDates, segmentSearchParams, isOpen, isSelected, onSelectDate, renderTrigger }) => {
    var _a;
    const { t } = useTranslation('Exchange');
    const { Datepicker: theme } = useTheme('Exchange');
    const { Segments: segmentsTheme } = useTheme('Widgets').Exchange;
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const isTablet = useMediaQuery({ maxWidth: TABLET_MIN_WIDTH });
    const { dates } = useAvailableDates(segmentSearchParams);
    const { isOpen: isOpenDatepicker, open, close } = useToggleable(false);
    useEffect(() => {
        if (isOpen) {
            open();
        }
    }, [isOpen]);
    const onSelectDateHandler = (date) => {
        close();
        onSelectDate(date);
    };
    return (React.createElement(React.Fragment, null, (_a = renderTrigger === null || renderTrigger === void 0 ? void 0 : renderTrigger(open, isOpen)) !== null && _a !== void 0 ? _a : (React.createElement(BaseButton, { variant: "optionAction", className: segmentsTheme.button, disabled: !isSelected, startIcon: React.createElement(CdnIcon, { icon: "Action/Show Calendar" }), onClick: open }, date ? format(date, 'dd MMM') : t('Datepicker.SelectDate'))),
        React.createElement(ModalX, { classes: { paper: segmentsTheme.paper }, size: isMobile ? 'fullscreen' : 'xlarge', title: React.createElement(Header, { className: segmentsTheme.header, left: React.createElement("span", { className: segmentsTheme.title }, t('Select new date')), showEmptySlots: false, equalSlotsBasis: false, onGoBackward: close }), noPadding: true, isOpen: isOpenDatepicker, onClose: close },
            React.createElement(DatepickerComponent, { popupDatepickerStyles: theme.monthsWrapperStyles_wrapper, minDate: minDate, openDate: minDate !== null && minDate !== void 0 ? minDate : date, monthCount: isTablet ? (isMobile ? 12 : 2) : 3, monthsToScroll: isTablet ? 2 : 3, selectedDates: selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], availableDates: dates !== null && dates !== void 0 ? dates : [], onSelect: onSelectDateHandler }))));
};
export default SelectDate;
